import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPortalOutlinedFileIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M5.5 7C5.22386 7 5 7.22386 5 7.5C5 7.77614 5.22386 8 5.5 8H10.5C10.7761 8 11 7.77614 11 7.5C11 7.22386 10.7761 7 10.5 7H5.5Z",
			fill: "#4B7987"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5 9.5C5 9.22386 5.22386 9 5.5 9H10.5C10.7761 9 11 9.22386 11 9.5C11 9.77614 10.7761 10 10.5 10H5.5C5.22386 10 5 9.77614 5 9.5Z",
			fill: "#4B7987"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5 11.5C5 11.2239 5.22386 11 5.5 11H7.5C7.77614 11 8 11.2239 8 11.5C8 11.7761 7.77614 12 7.5 12H5.5C5.22386 12 5 11.7761 5 11.5Z",
			fill: "#4B7987"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.5 0H4C2.89543 0 2 0.89543 2 2V14C2 15.1046 2.89543 16 4 16H12C13.1046 16 14 15.1046 14 14V4.5L9.5 0ZM9.5 1V3C9.5 3.82843 10.1716 4.5 11 4.5H13V14C13 14.5523 12.5523 15 12 15H4C3.44772 15 3 14.5523 3 14V2C3 1.44772 3.44772 1 4 1H9.5Z",
			fill: "#4B7987"
		})
	]
});
const ForwardRef = forwardRef(SvgPortalOutlinedFileIcon);
const Memo = memo(ForwardRef);
export default Memo;
